/*
 * @Author: wuqinfa
 * @Date: 2024-02-07 16:09:14
 * @LastEditors: wuqinfa
 * @Description: 
 */
import { RuntimeConfig, useSelector, useDispatch, } from 'umi';
import { LogoutOutlined, KeyOutlined, } from '@ant-design/icons';
import { Dropdown, } from 'antd';

import { goToLogin } from '@/utils';

export const dva: RuntimeConfig['dva'] = {
  config: {
    onError(err: Error) {
      // return Promise.reject(err);
    },
  },
};

export const locale: RuntimeConfig['locale'] = {
  onError: (err) => {
    // TODO: 会一直报错，不知道为啥
    // console.log('error handler...', err);
  }
};

export const layout: RuntimeConfig['layout'] = () => {
  const dispatch = useDispatch();

  const userInfo = useSelector((state: any) => state.global.userInfo);

  const handleMenuClick = ({ key }: any) => {
    if (key === 'changePassword') {
      dispatch({
        type: 'global/_setState',
        payload: {
          isOpenChangePassword: true,
        },
      });
    } else if (key === 'logout') {
      goToLogin();
    }
  };
  
  return {
    // logo: 'https://res.miaocode.com/web-3.0/login-logo-1707297793140.png',
    logo: 'https://res.miaocode.com/web-3.0/logo1-1709020544347.png',
    title: '',
    layout: 'top',
    breadcrumbRender: (route = []) => [
      {
        path: '/',
        breadcrumbName: '首页',
      },
      ...route,
    ],
    avatarProps: {
      src: '',
      title: userInfo.accountName,
      render: (props, dom) => {
        return (
          <Dropdown
            menu={{
              items: [
                {
                  key: 'changePassword',
                  icon: <KeyOutlined />,
                  label: '修改密码',
                },
                {
                  key: 'logout',
                  icon: <LogoutOutlined />,
                  label: '退出登录',
                },
              ],
              onClick: handleMenuClick,
            }}
          >
            {dom}
          </Dropdown>
        );
      },
    }
  };
}

